import { DownloadOutlined } from '@ant-design/icons';
import {
  IWidgetType,
  WidgetCategory,
  WidgetMainType,
  tran,
} from '@framework/engine';
import { DownloadWidgetComponent } from './DownloadWidgetComponent';
import {
  DownloadWidgetConfigComponent,
  DownloadWidgetConfigSchema,
} from './DownloadWidgetConfigComponent';
import { IDownloadWidget, WidgetDownloadType } from './IDownloadWidget';

declare module '@framework/engine/src/schema/widgets/Widget' {
  export enum WidgetType {
    Download = 'download',
  }
}

/**
 * Struttura del widget di download
 */
export const DownloadWidgetType: IWidgetType<IDownloadWidget> = {
  type: WidgetDownloadType,
  mainType: WidgetMainType.Graphic,
  category: WidgetCategory.Graphic,
  name: 'Download File',
  icon: <DownloadOutlined />,
  hasValue: false,
  formComponent: DownloadWidgetComponent,
  previewComponent: DownloadWidgetComponent,
  configValidator: DownloadWidgetConfigSchema,
  configComponent: DownloadWidgetConfigComponent,
  configOptions: {},
  // Traduzioni
  translationSchema: tran.widget({
    label: tran.rte(),
    helpText: tran.rte(),
  }),
  rules: [],
};
